import type { ColumnMetadata } from '../grid';

export type ApiMenuItem = {
  Id: number;
  Caption: string;
  Icon: string;
  Link: string | null;
  LinkId: number | null;
  ContentType: string;
  Roles: string;
  Visible: boolean;
  Childs: ApiMenuItem[];
  NodeKey: string | null;
};

export type MenuItem = {
  id: number;
  caption: string;
  icon: string;
  link: string | null;
  linkId: number | null;
  contentType: string;
  roles: string;
  visible: boolean;
  childs: MenuItem[];
  nodeKey: string | null;
};

export function mapApiMenuItemToMenuItem(apiItem: ApiMenuItem): MenuItem {
  return {
    id: apiItem.Id,
    caption: apiItem.Caption,
    icon: apiItem.Icon,
    link: apiItem.Link,
    linkId: apiItem.LinkId,
    contentType: apiItem.ContentType,
    roles: apiItem.Roles,
    visible: apiItem.Visible,
    childs: (apiItem.Childs || []).map(mapApiMenuItemToMenuItem),
    nodeKey: apiItem.NodeKey,
  };
}
export function mapApiMenuItemsToMenuItems(apiItems: ApiMenuItem[]): MenuItem[] {
  return apiItems.map(mapApiMenuItemToMenuItem);
}

export type ApiResponse<T> = {
  code?: number;
  Code?: number;
  data: T;
  message: string;
};

export type GetGridMetadataParams = {
  menuItemId?: number;
  nodeKey?: string;
  parentId?: string;
};

export const GridType = {
  GridWithDetail: 'GridWithDetail',
  Inline: 'InlineEdit',
} as const;
export type GridType = (typeof GridType)[keyof typeof GridType];

export type GridMetadata = {
  contentId: number;
  contentKey: string;
  contentType: string;
  dataSource: string;
  title: string | null;
  columns: ColumnMetadata;
  gridType?: GridType;
  numberOfRowsPerPage?: number;
  usePaging?: boolean;
  defaultSortingColumn?: string | null;
  defaultSortingOrder?: string | null;
  detailFormId?: number;
  detailFormKey?: string;
  commands?: Command[];
  filters?: DropdownRowFilter[];
  showFilterPanel?: boolean;
  dataOptionsMax?: boolean;
  wordWrap?: boolean;
  showSearchPanel?: boolean;
  hidePaginationPanel?: boolean;
  shrinkToRowNumbers?: boolean;
  showLoadingPanel?: boolean;
  configurationTables?: string;
  parentSource?: string | null;
  userRelationDays?: number | null;
  userRelationVacationDays?: string | null;
  canEditLockedWorkLogs?: boolean;
  currentUserRelationId?: number;
};

export type ApiMenuItemStructure = {
  menuItemId: number;
  buttons: ApiMenuItem[];
};

export type MenuItemStructure = {
  menuItemId: number;
  buttons: MenuItem[];
};

export function mapApiMenuItemStructure(apiStructure: ApiMenuItemStructure): MenuItemStructure {
  return {
    menuItemId: apiStructure.menuItemId,
    buttons: (apiStructure.buttons || []).map(mapApiMenuItemToMenuItem),
  };
}

export type GetMenuItemStructureParams = {
  menuItemId: number;
};

export type DropdownRowFilter = {
  Kind: string;
  Field: string;
  Operation: string;
  Value: string;
  Options: { Not: boolean; Collection: string | null; Or: boolean } | null;
};

/**
 * Grid command metadata from backend (already in camelCase from serialization)
 */
export type Command = {
  key: string;
  alias: string;
  icon: string | null;
  caption: string;
  isGroup: boolean;
  action: string | null;
  location: string | null;
  settings: string | null;
  hintForStateDisabled: string | null;
  templateSelection: string | null;
  isInlineEdit: boolean;
  requireSelection?: boolean | null;
  dateFilter: string | null;
  defaultRange: string | null;
  disableDeleted: boolean;
  isAddPeopleProject: boolean;
  renderingClass: string | null;
  pathToJs: string | null;
  jsonOptions: string | null;
  displayFormat: string | null;
  saveForm: boolean;
  closeForm: boolean;
  performReload: boolean;
};
